import React, { useEffect, useRef } from 'react'
import _ from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import Template from 'src/components/Template'
import { Column } from 'src/components/Layout/Styled'

import ContentNoClass from 'src/components/ContentNoClass'

import FilterHeader from './FilterHeader'
import ClassCard from './ClassCard'
import Header from './Header'
import { StyledContainer, StyledLoading } from './Styled'
import { fetchAnnounceExaminerList, handleLoadMore, handleSeeMore } from './event'
import Divider from '@mui/material/Divider'

const AnnounceExaminer = () => {
  const dispatch = useDispatch()
  const { isLoadMore, announceList, filterBody } = useSelector(
    (state) => state.announceExaminerList,
    shallowEqual
  )
  const triggerProps = [
    filterBody.search,
    filterBody.startDate,
    filterBody.endDate,
  ]

  const onScrollRef = useRef(null)

  useEffect(() => {
    window.scrollTo(0, 0)
    onScrollRef.current = _.throttle(
      () => dispatch(handleLoadMore()),
      300,
      { leading: true, trailing: true }
    )
    window.addEventListener('scroll', onScrollRef.current)
    return () => {
      window.removeEventListener('scroll', onScrollRef.current)
      onScrollRef.current.cancel()
    }
  }, [])

  useEffect(() => {
    dispatch(fetchAnnounceExaminerList(filterBody))
  }, [...triggerProps])

  useEffect(() => {
    dispatch(handleSeeMore(filterBody))
  }, [filterBody.page])

  return (
    <>
      <Header />
      <Template>
        <StyledContainer>
          <Column gap={3}>
            <FilterHeader />
            <Column>
              {announceList.length > 0 ? (
                announceList.map((item, index) => (
                  <React.Fragment key={index}>
                    <Divider />
                    <ClassCard data={item} index={index} />
                  </React.Fragment>
                ))
              ) : (
                <ContentNoClass />
              )}
              {isLoadMore && <StyledLoading />}
            </Column>
          </Column>
        </StyledContainer>
      </Template>
    </>
  )
}

export default AnnounceExaminer
